import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {Text} from '../../atoms/Text/Text';
import {OptionContent} from '../SizeOption/OptionContent';
import {SizeOptionProps} from '../SizeOption/types';

export interface SizeSelectorProps {
  selection?: SizeOptionProps;
  onClick?: () => void;
}
export const SizeSelector: FC<SizeSelectorProps> = ({selection, onClick}) => {
  const {t} = useTranslation();

  if (!selection) {
    return (
      <Wrapper data-testid="sizeSelector_empty" onClick={onClick}>
        <StyledText
          data-testid="sizeSelector_label"
          size="px14"
          weight="mediumBold"
          color="Black"
        >
          {t('Select size')}
        </StyledText>
      </Wrapper>
    );
  }

  return (
    <WithSelectionWrapper
      data-testid={`sizeSelector_size_${selection.id}_selected`}
      onClick={onClick}
    >
      <StyledOptionContent
        dataTestId="sizeSelectorSizeSelectedText"
        showYourSizeInfoIcon={false}
        {...selection}
      />
    </WithSelectionWrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 2px;
  cursor: pointer;
`;

const WithSelectionWrapper = styled(Wrapper)`
  justify-content: flex-start;
`;

const StyledText = styled(Text)`
  margin: 1rem;
`;

const StyledOptionContent = styled(OptionContent)`
  flex: 1;
`;
